<template>
    <template v-if="isLoaded">
        <ContainerXxl>
            <div v-if="!catalogStore.mobileSearch" :class="currentComponentName">
                <Breadcrumbs />
            </div>
            <ProductPage v-if="currentComponentName === 'product'"  />
            <CatalogPage v-else-if="currentComponentName === 'catalog'"  />
            <Error404 v-else-if="currentComponentName === 'not_found'"/>
        </ContainerXxl>
    </template>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { useRouterStore } from '~/stores/RouterStore';
import { useCatalogStore } from '~/stores/CatalogStore';
import ProductPage from '~/components/Product/Page/ProductPage.vue';
import CatalogPage from '~/components/Catalog/CatalogPage.vue';
import Error404 from '~/errors/Error404.vue';
import Breadcrumbs from '~/components/Breadcrumbs.vue';
import ContainerXxl from '~/layouts/container-xxl.vue';
import { useLocalePath } from '#imports';

const route = useRoute();
const routerStore = useRouterStore();
const catalogStore = useCatalogStore();

const currentPageData = ref(null);
const currentComponentName = ref('');
const isLoaded = ref(false);


const updatePageDataAndComponent = async () => {
    let pageData = routerStore.getPage(route.path) || {};

    currentPageData.value = pageData;

    if (!pageData.name) {
        currentComponentName.value = '';
        isLoaded.value = true;
        return;
    }

    switch (pageData.name) {
        case 'product':
            currentComponentName.value = 'product';
            gtm.openPage('product');
            break;
        case 'catalog':
            catalogStore.catalogResource = pageData.catalog;
            currentComponentName.value = 'catalog';
            gtm.openPage('catalog');
            break;
        default:
            currentComponentName.value = 'not_found';
            break;
    }

    isLoaded.value = true;
};

const localePath = useLocalePath();

watch(
    () => route.path,
    (newPath, oldPath) => {
        if (newPath !== oldPath) {
            isLoaded.value = false;
            updatePageDataAndComponent();
            if (currentComponentName.value === 'not_found') {
                navigateTo(localePath({name: '404'}), { redirectCode: 301});
            }
        }
    },
    { immediate: true }
);

definePageMeta({
    middleware: ['page-router', 'catalog-pagination', 'language-redirect'],
});

</script>
